const STORAGE_KEY = 'voltide_savings_assumptions';

export const DEFAULTS = {
  diesel_price_inr_per_litre: 90,
  dg_kwh_per_litre: 3.5,
  grid_tariff_inr_per_kwh: 10.5,
  dg_hours_per_day: 4,
};

export function loadAssumptions() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? { ...DEFAULTS, ...JSON.parse(stored) } : { ...DEFAULTS };
  } catch { return { ...DEFAULTS }; }
}

export function saveAssumptions(a) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(a));
}

export function estimateMonthlySavings(battery_kwh, assumptions = DEFAULTS) {
  const a = { ...DEFAULTS, ...assumptions };
  const diesel_cost_per_kwh = a.diesel_price_inr_per_litre / a.dg_kwh_per_litre;
  const daily_kwh = battery_kwh * 0.8;
  const daily_dg_cost = daily_kwh * diesel_cost_per_kwh;
  const daily_bess_cost = daily_kwh * a.grid_tariff_inr_per_kwh * 1.1;
  const daily_savings = daily_dg_cost - daily_bess_cost;
  const monthly_low = Math.round(daily_savings * 25 * 0.7);
  const monthly_high = Math.round(daily_savings * 28 * 1.0);
  return { low: Math.max(0, monthly_low), high: Math.max(0, monthly_high), diesel_cost_per_kwh: Math.round(diesel_cost_per_kwh * 10) / 10 };
}

export function formatINR(n) {
  if (!n) return '—';
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n);
}

export function formatINRCompact(n) {
  if (!n) return '—';
  if (n >= 100000) return `₹${(n / 100000).toFixed(1)}L`;
  if (n >= 1000) return `₹${(n / 1000).toFixed(0)}K`;
  return `₹${n}`;
}
